import {Injectable} from '@angular/core';
import {BaseService, QueryParams} from '../../../../../core/abstracts/base-service.abstract';
import {Pageable} from '../../../../../core/interfaces/base-service.interfaces';
import {Observable} from 'rxjs';
import {PageableRequest} from '../../../../../core/models/pagable.model';
import {PageableResponse} from '../../../../../core/models/page-response.model';
import {HttpClient} from '@angular/common/http';
import {VehicleSearchFilterRequest} from '../models/vehicle-search-filter-request.model';
import {VehicleSearchResponse} from '../models/vehicle-search-response.model';

@Injectable({providedIn: 'root'})
export class VehicleListService extends BaseService implements Pageable<VehicleSearchResponse> {
  protected override readonly endpoint: string = 'items';

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  getPage(
    pageable: PageableRequest,
    filters?: VehicleSearchFilterRequest
  ): Observable<PageableResponse<VehicleSearchResponse>> {

    const params: QueryParams = {
      ...pageable.toParams(),
      ...filters
    };

    return this.get<PageableResponse<VehicleSearchResponse>>('', params);
  }
}
